// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-row .selection-cell[data-v-4e4537e1]{text-align:center;vertical-align:middle;width:41px}.is-selected[data-v-4e4537e1]{background-color:#e0f4fd !important}", ""]);
// Exports
module.exports = exports;
